import * as React from 'react';
import { DatasheetItem } from '@modules/datasheets/components/datasheet-item';
import { DatasheetItemLabel } from '@modules/datasheets/components/datasheet-item-label';
import { DropdownFieldProps, useDropdownFieldController } from './dropdown-field.controller';
import { Flex } from '@common/components/Flex';
import { DatasheetFieldComponentHeadingPosition } from '@common/dto/datasheet/field-component/heading-position';
import { FieldContainer } from '../field-container';
import { Hint } from '@common/components/hint';
import Dropdown from '@common/containers/fields/Dropdown';

import './dropdown-field.styles.scss';

export const DropdownField: React.FC<DropdownFieldProps> = React.memo((props) => {
  const { datasheetElement } = props;

  const { 
    headingPlacedHorizontally,
    headingReference,
    headingSize,
    headingPosition,
    handleFieldValueSave,
    normalizeDropdownOptions
  } = useDropdownFieldController(props);

  const labelComponent = (
    <DatasheetItemLabel
      reference={headingReference}
      inline={headingPlacedHorizontally}
      withImg={datasheetElement.original.showfieldtype}
      withText={datasheetElement.original.headdisplay}
      text={datasheetElement.original.headtext} 
      img={datasheetElement.original.field.imageURL}
      textCustomization={{
        fontSize: datasheetElement.original.headfontsize,
        fontFamily: datasheetElement.original.headfont,
        color: datasheetElement.original.headcolor,
        align: datasheetElement.original.headalign,
        fontStyles: datasheetElement.original.headstyle,
      }}
    />
  );

  return (
    <DatasheetItem
      style={{
        top: datasheetElement.coordinates.y - (datasheetElement.original.headpos === DatasheetFieldComponentHeadingPosition.top 
          ? headingSize.height
          : 0),
        left: datasheetElement.coordinates.x - (datasheetElement.original.headpos === DatasheetFieldComponentHeadingPosition.left 
          ? headingSize.width 
          : 0),
        display: headingPlacedHorizontally ? 'flex' : 'block',
        alignItems: headingPlacedHorizontally ? 'flex-start' : undefined,
        width: datasheetElement.width,
      }}
    >
      {[
        DatasheetFieldComponentHeadingPosition.top, 
        DatasheetFieldComponentHeadingPosition.left
      ].includes(headingPosition) && labelComponent}
      <Flex alignItems="center">
        <FieldContainer
          width={datasheetElement.original.width}
          height={datasheetElement.original.height}
          showBorder={datasheetElement.original.showborder}
          className="DatasheetsResultDropdownField__field-container"
        >
          <Dropdown
            fullWidth
            // selectedValue={datasheetElement.original.field.value}
            selectedValue=""
            options={normalizeDropdownOptions}
            onValueChanged={handleFieldValueSave}
          />
        </FieldContainer>
        {datasheetElement.original.helptext && (
          <Hint description={datasheetElement.original.helptext} />
        )}
      </Flex>
      {[
        DatasheetFieldComponentHeadingPosition.bottom, 
        DatasheetFieldComponentHeadingPosition.right
      ].includes(headingPosition) && labelComponent}
    </DatasheetItem>
  );
});